/*** IMPORTS FROM imports-loader ***/
var define = false;

/**
 * ########################################
 * Init Slick Slider
 * ########################################
 */
$('.slider-quote').slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    dots: true,
    prevArrow:"<i class='fa fa-angle-left slick-prev'></i>",
    nextArrow:"<i class='fa fa-angle-right slick-next'></i>",
});

